import Vue from 'vue'
export { default as ElCollapseTransition } from 'element-ui/lib/transitions/collapse-transition'
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 500 }

export * from './form/index'
export * from './layout-main/index'
export * from './config-provider/index'
export * from './message/index'
export * from './message-box/index'
export * from './notification/index'
export * from './table/index'
export * from './pagination/index'
export * from './page-edit/index'
export * from './store-provider/index'
export * from './button-group/index'
export * from './color-mix/index'
export * from './drawer-print-template-select/index'
export * from './drawer-form/index'
export * from './select/index'
export * from './button-actions-context/index'
export * from './page-edit-table/index'
export * from './click-to-router/index'
export * from './input-number/index'
export * from './page-query/index'
export * from './page-echart/index'
export * from './top-remind/index'
export * from './checkbox/index'
export * from './checkbox-group/index'
export * from './radio/index'
export * from './radio-group/index'
export * from './input/index'
export * from './input-scan/index'
export * from './page-query-drawer-search/index'
export * from './dialog-form/index'
export * from './dialog-table/index'
export * from './drawer-serial-select/index'
export * from './scan-update-items/index'
export * from './float-container/index'
export * from './drawer-export/index'
export * from './dialog-select/index'
export * from './page-query-top-search/index'
export * from './drawer-search-table/index'
export * from './page-flowchat/index'
export * from './flash-add-medical/index'
export * from './criteria-form/index'
export * from './page-query-order/index'
export * from './tree/index'
export * from './monaco-editor/index'
export * from './dialog-update-result/index'
export * from './design/index'
export * from './tabs/index'
export * from './dialog-scan/index'
export * from './udi-scan/index'
export * from './dialog-select-model/index'
export * from './input-cell-edit/index'
export * from './read-text/index'
export * from './date-picker/index'
export * from './input-range/index'
export * from './upload/index'
export * from './image/index'
export * from './dialog-textArea/index'
export * from './ocr/index'
export * from './file-preview/index'
export * from './image-point/index'
export * from './expire/index'
export * from './left-form-right-content/index'
export * from './text-tip/index'
export * from './dialog-select-icon/index'

export {
  Dialog as ElDialog,
  Button as ElButton,
  Form as ElForm,
  FormItem as ElFormItem,
  Loading as ElLoading,
  Dropdown as ElDropdown,
  DropdownMenu as ElDropdownMenu,
  DropdownItem as ElDropdownItem,
  Alert as ElAlert,
  Tag as ElTag,
} from 'element-ui'
